let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("FsNwF")).then(() => parcelRequire('jRDDZ'));